export default "__VITE_ASSET__1d0d0c65__"